module.exports = __webpack_public_path__ + "img/details_2.2684aa18.jpg";